export const DEFAULT_HIERARCHY_OFFSET_CATEGORY = 8;
export const DEFAULT_HIERARCHY_OFFSET_SUBCATEGORY = 25;
export const DEFAULT_HIERARCHY_OFFSET_INDICATOR = 28;

export const RADIO_HIERARCHY_OFFSET_CATEGORY = 0;
export const RADIO_HIERARCHY_OFFSET_SUBCATEGORY = 16;
export const RADIO_HIERARCHY_OFFSET_INDICATOR = 24;

export const CHECKBOX_HIERARCHY_OFFSET_CATEGORY = 0;
export const CHECKBOX_HIERARCHY_OFFSET_SUBCATEGORY = 16;
export const CHECKBOX_HIERARCHY_OFFSET_INDICATOR = 16;
